import { getAllInOneReduxState } from '../index';
import { isLinux } from 'utils/platform';
import { isZh } from 'utils/zhEn';
import { BillingTeamType } from "utils/constants/billing";
/**
 * i18n with context。用来套在ze或者i18n的t函数外面，效果是根据某些上下文（比如appId, pid等），自动替换掉文案里面的部分关键词
 * 最初的需求是linux端，需要把所有的”设备“文案都换成”会话“。后面也可以用来实现一些定制化替换。比如王者项目要把”卡死“改成”疑似卡死“
 * */
export function ix(text) {
    if (!text || typeof text !== 'string') {
        return text;
    }
    const state = getAllInOneReduxState();
    if (!state) {
        return text;
    }
    const appId = state.app?.get('current')?.get('appId');
    const pid = state.app?.get('current')?.get('pid');
    const appName = state.app?.get('current')?.get('name');
    const teamType = state.app?.get('current')?.get('teamType');
    // linux端，把所有的”设备“都换成”会话“
    if (isLinux(pid, appId)) {
        if (isZh()) {
            return text.replace(/设备/g, '会话');
        }
        else {
            return text
                .replace(/Device/g, 'Session')
                .replace(/device/g, 'session');
        }
    }
    // 王者定制需求，”卡死“要写成”疑似卡死“  --story=126200409 【CS】 王者卡死的文字描述，变更为 疑似卡死
    if (teamType === BillingTeamType.TENCENT && appName?.startsWith('王者')) {
        return text.replaceAll('卡死', '疑似卡死');
    }
    return text;
}
